var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { InformationCircleIcon } from "@heroicons/react/24/solid";
import { classNames } from "../Util";
var TooltipIndicator = function (_a) {
    var tip = _a.tip, className = _a.className;
    return (_jsx("div", __assign({ className: "inline", "data-tip": tip }, { children: _jsx(InformationCircleIcon, { className: classNames("inline ml-1 w-4 cursor-help outline-0 opacity-70 hover:opacity-100", className ? className : "") }) })));
};
export default TooltipIndicator;
